<template>
<div class="article">
    <div class="article-top">
        <div class="top-center">
            <div class="path"><a href="/" target="_blank">{{ $t("faq.breadcrumb.home") }}</a>/<span>{{ $t("faq.breadcrumb.faq") }}</span></div>
            <h1>{{ $t("faq.title") }}</h1>
            <div class="search-box">
                <input v-model="searchValue" @keypress="handleKeyPress" class="outline-none" type="text" :placeholder="$t('faq.search_placeholder')">
                <div class="search-btn" @click="handleSearchClick">
                    <img src="@/assets/index/img/faq/icon_search.png" alt="search">
                </div>
            </div>
            <div class="article-left">    
              <span
                v-for="category in categories"
                :key="category.id"
                :data-id="category.id"
                @click="faqMainList(category.id, category.name, searchValue)"
                :class="{ active: category.id === activeCategoryId }"
                class="coua">
                {{ category.name }}
              </span>            
            </div>
        </div>
        
    </div>
    <div class="article-bottom">
        <div class="allAnswer">
            <div class="fq-type-title">{{ faqTitle }}</div>
            <div class="fq-type-content min-h-[500px]">
              <el-empty v-if="!loading && faqs.length === 0" :description="$t('faq.empty_view')"></el-empty>
              <el-skeleton :rows="6" animated :loading="loading">
                <div v-for="(faq, index) in faqs" :key="faq.id" class="fq" :class="animationClass(index)">
                  <a :href="`/faq/${faq.subtitle}.html`" target="_blank">
                    <div class="f">
                      <span>{{ faq.title }}</span>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                    <div class="q">{{ faq.content }}</div>
                  </a>
                </div>
              </el-skeleton>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {listFaqCategoires, listCategoryFaqs} from '@/http/api/faq'

export default {
  name: 'faq',
  data(){
    return {
      loading: false,
      categories: [],
      faqs: [],
      searchValue: '',
      activeCategoryId: null,
      faqTitle: '',
      showSearchAnswer: false
    }
  },
  mounted() {
    this.fetchCategories();
    if (window.location.search.includes('search')) {
      const params = new URL(window.location.href).searchParams;
      const searchValue = params.get('search');
      const classId = params.get('class');
      this.faqMainList(classId, '', searchValue);
      this.searchValue = searchValue;
      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i].id === parseInt(classId)) {
          this.activeCategoryId = this.categories[i].id;
          break;
        }
      }
    }
  },
  methods:{
    animationClass(index) {
      return `animate-slide-in delay-${index * 100}`;
    },
    fetchCategories() {
      this.loading = true;
      listFaqCategoires().then(response => {
        this.categories = response.data;
        if (this.categories.length > 0) {
          this.activeCategoryId = this.categories[0].id;
          this.faqMainList(this.categories[0].id, this.categories[0].name);
        }
      }).catch((e) => {
        this.loading = false;

        this.$message.error(this.$t("faq.message.load_category_fails"));
      });
    },
    faqMainList(id, title, search = '') {
      this.activeCategoryId = id;
      if (title !== '') {
        this.faqTitle = title;
      }
      this.faqs = [];
      this.loading = true;

      const params = {
        categoryId: id,
        keywords: search
      };
      listCategoryFaqs(params).then(response => {
        this.faqs = response.data;
      }).catch(e => {
        this.$message.error(this.$t("faq.message.load_faq_fails"));
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSearchClick() {
      if (this.searchValue === '') {
        return false;
      }
      this.faqMainList(this.activeCategoryId, '', this.searchValue);
    },
    handleKeyPress(event) {
      if (event.key === 'Enter') {
        if (this.searchValue === '') {
          return false;
        }
        this.faqMainList(this.activeCategoryId, '', this.searchValue);
      }
    },
  }
}
</script>
<style lang="scss" scoped>
@keyframes slide-in {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-slide-in {
  animation: slide-in 0.5s ease-out forwards;
}

.delay-0 {
  animation-delay: 0s;
}
.delay-100 {
  animation-delay: 0.1s;
}
.delay-200 {
  animation-delay: 0.2s;
}
.delay-300 {
  animation-delay: 0.3s;
}
.delay-400 {
  animation-delay: 0.4s;
}
.delay-500 {
  animation-delay: 0.5s;
}

.article {
    padding-bottom: 200px;
    color: #1c3b3b;
}

.article .article-top {
    padding-top: 138px;
    background-color: rgb(240, 242, 248);
    padding-bottom: 72px;
}

.article .article-top .top-center {
    max-width: 1200px;
    margin: auto;
}

.article .article-top .top-center .path {
    font-size: 16px;
    line-height: 27px;
    color: rgba(34, 50, 101, 0.3);
    font-family: Poppins-Medium;
    margin-bottom: 34px;
}

.article .article-top .top-center .path a {
    font-size: 16px;
    color: rgba(34, 50, 101, 0.3);
    font-family: Poppins-Medium;
}

.article .article-top .top-center .path span {
    color: rgb(34, 50, 101);
}

.article .article-top .top-center h1 {
    font-size: 56px;
    line-height: 64px;
    color: rgb(34, 50, 101);
    font-family: Poppins-Bold;
    margin-bottom: 16px;
}

.article .article-top .top-center .search-box {
    max-width: 735px;
    height: 64px;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(11, 31, 75, 0.1) 0px 3px 21px 0px;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 0px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;
}

.article .article-top .top-center .search-box input {
    width: calc(100% - 32px);
    border: 0px;
    font-size: 18px;
    color: rgb(34, 50, 101);
}

.article .article-top .top-center .search-box .search-btn {
    width: 25px;
    height: 25px;
    cursor: pointer;
}

.article .article-top .top-center .article-left {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.article .article-top .top-center .article-left .coua {
    padding: 0px 16px;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    color: rgb(34, 50, 101);
    display: inline-block;
    cursor: pointer;
}

.article .article-top .top-center .article-left .coua.active {
    background-color: rgba(39, 109, 253, 0.1);
    box-shadow: rgba(11, 31, 75, 0.05) 0px 3px 21px 0px;
    border-radius: 6px;
}

.article .article-bottom {
    max-width: 1200px;
    margin: auto;
}

.article .article-bottom .allAnswer, .article .article-bottom .search-answer {
    padding-top: 44px;
}

.article .article-bottom .allAnswer .fq-type-title, .article .article-bottom .search-answer .fq-type-title {
    font-size: 24px;
    line-height: 27px;
    color: rgb(34, 50, 101);
    font-family: Poppins-SemiBold;
    padding: 16px 30px 0px;
    margin-bottom: 20px;
    // display: none;
}

.article .article-bottom .allAnswer .fq-type-content .fq, .article .article-bottom .search-answer .fq-type-content .fq {
    margin-bottom: 5px;
}

.article .article-bottom .allAnswer .fq-type-content .fq .f, .article .article-bottom .search-answer .fq-type-content .fq .f {
    display: flex;
    align-items: center;
    padding: 20px 30px;
    cursor: pointer;
    justify-content: space-between;
    box-shadow: rgba(11, 31, 75, 0.1) 0px 3px 21px 0px;
}

.article .article-bottom .allAnswer .fq-type-content .fq .f span, .article .article-bottom .search-answer .fq-type-content .fq .f span {
    font-size: 16px;
    line-height: 27px;
    color: rgb(34, 50, 101);
}

.article .article-bottom .allAnswer .fq-type-content .fq .q, .article .article-bottom .search-answer .fq-type-content .fq .q {
    font-size: 16px;
    line-height: 27px;
    color: rgb(34, 50, 101);
    font-family: Poppins-Medium;
    padding: 0px 30px;
    display: none;
}

.article .article-bottom .allAnswer .fq-type-content .fq.active, .article .article-bottom .search-answer .fq-type-content .fq.active {
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(11, 31, 75, 0.1) 0px 3px 21px 0px;
    border-radius: 10px;
    padding-bottom: 32px;
}

.article .article-bottom .allAnswer .fq-type-content .fq.active .f, .article .article-bottom .search-answer .fq-type-content .fq.active .f {
    box-shadow: none;
}

.article .article-bottom .allAnswer .fq-type-content .fq.active .f span, .article .article-bottom .search-answer .fq-type-content .fq.active .f span {
    color: rgb(39, 109, 253);
}

.article .article-bottom .allAnswer .fq-type-content .fq.active .q, .article .article-bottom .search-answer .fq-type-content .fq.active .q {
    display: block;
}

.article .article-bottom .search-answer .fq-type-content {
    display: block;
}

@media screen and (max-width: 1000px) {
    .article .article-top .top-center h1 {
        font-size: 50px;
    }
}

@media screen and (max-width: 700px) {
    .article .article-top .top-center h1 {
        font-size: 40px;
    }
}

@media screen and (max-width: 600px) {
    .article .article-top .top-center h1 {
        font-size: 35px;
    }
}

@media screen and (max-width: 500px) {
    .article .article-top .top-center h1 {
        font-size: 30px;
    }
}

@media screen and (max-width: 400px) {
    .article .article-top .top-center h1 {
        font-size: 26px;
    }
}
</style>
